export default "__VITE_ASSET__e2e0eae6__"